/**
 * Created by qlong on 10/5/2016.
 */
import React, {Component}  from 'react'
import NavigationLink from './NavigationLink'

const baseUrl = "/cessationStability/onlineVisualization" //Change to "/SpaghettiChart" for prod deployment
export default class NavigationBar extends Component{
    render(){
        const navLinks = this.props.visualizations.map((viz,i) =>
            <NavigationLink key={i} path={baseUrl + "/" + viz.routeName} text={viz.name}/>
        )
        return(
            <div className="navBar">
                {navLinks}
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/NavigationBar.js
 **/